/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-empty */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Fab,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChatIcon from "@mui/icons-material/Chat";
import { useNavigate, useLocation } from "react-router-dom";
import { useScreenContext, screenNameForRoute } from "context/ScreenContext";
import { useMsal } from "@azure/msal-react";
import { useNativeAuth } from "context/NativeAuthContext";
import { protectedResources } from "authConfig";

const API = protectedResources.apiTodoList.endpoint;
const SCOPES = protectedResources.apiTodoList.scopes?.[0]
  ? [protectedResources.apiTodoList.scopes[0]]
  : [];

// ── Auth token ────────────────────────────────────────────────────────────────

function useAuthToken() {
  const { instance } = useMsal();
  const { getAccessToken: getNativeAccessToken } = useNativeAuth();
  return useCallback(async () => {
    const native = getNativeAccessToken();
    if (native) return native;
    const account = instance.getActiveAccount();
    if (account && SCOPES.length) {
      const silent = await instance.acquireTokenSilent({ scopes: SCOPES, account });
      return silent?.accessToken || null;
    }
    return null;
  }, [instance, getNativeAccessToken]);
}

// ── SSE streaming ─────────────────────────────────────────────────────────────

async function streamMessage(url, body, token, onEvent) {
  const res = await fetch(url, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split("\n");
    buf = lines.pop();
    for (const line of lines) {
      if (!line.startsWith("data:")) continue;
      const payload = line.slice(5).trim();
      if (!payload) continue;
      try {
        onEvent(JSON.parse(payload));
      } catch (_) {}
    }
  }
}

// ── Action proposal card ──────────────────────────────────────────────────────

// Rendered when the advisor proposes an action (create watchlist risk / horizon search).
// The user reviews the details and confirms — nothing is created until they click Create.
const REPORT_TYPE_LABEL = {
  strategic: "Strategic (board)",
  operational: "Operational",
  tactical: "Tactical / action",
};

const LENGTH_LABEL = {
  short: "Short (~1 page)",
  standard: "Standard (~2 pages)",
  detailed: "Detailed (~4 pages)",
};

// Human-readable reporting period for a board_paper proposal.
function boardPaperPeriodLabel(data) {
  if (data.dateFrom && data.dateTo) return `${data.dateFrom} → ${data.dateTo}`;
  const m = Number(data.periodMonths);
  if (m > 0) return `Last ${m} month${m === 1 ? "" : "s"}`;
  return "Current snapshot";
}

function ProposalCard({ proposal, onConfirm, onDismiss, onOpen, onOpenBoardPaper }) {
  const { kind, data = {}, busy, done, error, result } = proposal;
  const isRisk = kind === "risk";
  const isBoardPaper = kind === "board_paper";

  let heading = "Create this horizon scan search?";
  if (isRisk) heading = "Add this to your watchlist?";
  else if (isBoardPaper) heading = "Generate this board paper?";

  let threatType = "";
  if (data.threatOpp === "gain") threatType = "Opportunity";
  else if (data.threatOpp === "loss") threatType = "Threat";

  let rows = [
    ["Search", data.name],
    ["Category", data.category],
    ["Cadence", data.ingestTier === "instant" ? "Instant" : "Daily"],
    ["Criticality", data.criticality],
  ];
  if (isRisk) {
    rows = [
      ["Risk", data.title],
      ["Category", [data.category, data.subCategory].filter(Boolean).join(" › ")],
      ["Time frame", data.timeFrame],
      ["Type", threatType],
    ];
  } else if (isBoardPaper) {
    let focus = "Whole portfolio";
    if (Array.isArray(data.focusRisks) && data.focusRisks.length) {
      focus = data.focusRisks.join(", ");
    } else if (Array.isArray(data.focusCategories) && data.focusCategories.length) {
      const l2 =
        Array.isArray(data.focusSubCategories) && data.focusSubCategories.length
          ? ` › ${data.focusSubCategories.join(", ")}`
          : "";
      focus = `${data.focusCategories.join(", ")}${l2}`;
    }
    const horizonFocus =
      Array.isArray(data.focusHorizonParams) && data.focusHorizonParams.length
        ? data.focusHorizonParams.join(", ")
        : "";
    rows = [
      ["Depth", REPORT_TYPE_LABEL[data.reportType] || REPORT_TYPE_LABEL.strategic],
      ["Focus", focus],
      ["Horizon focus", horizonFocus],
      ["Period", boardPaperPeriodLabel(data)],
      ["Length", LENGTH_LABEL[data.length] || LENGTH_LABEL.standard],
      ["Charts", data.includeCharts === false ? "No" : "Yes"],
      ["Template", data.template],
      ["Format", data.outputFormat === "pptx" ? "Slides (PPTX)" : "Word (DOCX)"],
    ];
  }

  if (done) {
    return (
      <Box
        sx={{
          alignSelf: "flex-start",
          maxWidth: "90%",
          border: "1px solid #c8e6c9",
          bgcolor: "#f1f8f2",
          borderRadius: 2,
          px: 1.5,
          py: 1,
          fontSize: 13,
          color: "#1b5e20",
        }}
      >
        <Box>
          {isRisk && `Added “${data.title}” to your watchlist as a draft.`}
          {isBoardPaper && "Your board paper is ready."}
          {!isRisk && !isBoardPaper && `Created the “${data.name}” horizon scan search.`}
        </Box>
        {isRisk && result && result.id && (
          <Button
            size="small"
            variant="text"
            onClick={() => onOpen && onOpen(result.id)}
            sx={{
              mt: 0.5,
              p: 0,
              minWidth: 0,
              color: "#7b1fa2",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Open risk →
          </Button>
        )}
        {isBoardPaper && result && result.reportId && (
          <Button
            size="small"
            variant="text"
            onClick={() => onOpenBoardPaper && onOpenBoardPaper(result.reportId)}
            sx={{
              mt: 0.5,
              p: 0,
              minWidth: 0,
              color: "#7b1fa2",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Open board paper →
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        maxWidth: "90%",
        border: "1px solid rgba(123,31,162,0.35)",
        bgcolor: "#fff",
        borderRadius: 2,
        px: 1.5,
        py: 1.25,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: "#7b1fa2", letterSpacing: 0.3, display: "block", mb: 0.75 }}
      >
        {heading}
      </Typography>
      {rows
        .filter(([, v]) => v)
        .map(([label, v]) => (
          <Box key={label} sx={{ display: "flex", gap: 1, py: 0.25, fontSize: 12.5 }}>
            <Typography sx={{ minWidth: 78, color: "#6a6478", fontSize: 12.5, flexShrink: 0 }}>
              {label}
            </Typography>
            <Typography sx={{ color: "#222028", fontSize: 12.5, fontWeight: 500 }}>{v}</Typography>
          </Box>
        ))}
      {data.description && (
        <Typography sx={{ color: "#4a4658", fontSize: 12, mt: 0.5, lineHeight: 1.45 }}>
          {data.description}
        </Typography>
      )}
      {isBoardPaper && (data.dateFrom || Number(data.periodMonths) > 0) && (
        <Typography sx={{ color: "#6a6478", fontSize: 11, mt: 0.5, lineHeight: 1.4 }}>
          The period scopes the news &amp; emerging themes analysed. Watch-list risk positions
          always reflect their current assessment.
        </Typography>
      )}
      {error && <Typography sx={{ color: "#c62828", fontSize: 12, mt: 0.75 }}>{error}</Typography>}
      {isBoardPaper && busy && (
        <Typography sx={{ color: "#6a6478", fontSize: 11.5, mt: 0.75, fontStyle: "italic" }}>
          Drafting your board paper from the live portfolio — this can take up to a minute.
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
        <Button
          size="small"
          variant="contained"
          disabled={busy}
          onClick={onConfirm}
          startIcon={busy ? <CircularProgress size={13} color="inherit" /> : <AddIcon />}
          sx={{
            bgcolor: "#7b1fa2",
            color: "#fff",
            textTransform: "none",
            fontSize: 12.5,
            "&:hover": { bgcolor: "#6a1b9a" },
          }}
        >
          {isRisk && "Add to watchlist"}
          {isBoardPaper && "Generate board paper"}
          {!isRisk && !isBoardPaper && "Create search"}
        </Button>
        <Button
          size="small"
          disabled={busy}
          onClick={onDismiss}
          sx={{ color: "#6a6478", textTransform: "none", fontSize: 12.5 }}
        >
          Not now
        </Button>
      </Box>
    </Box>
  );
}

// ── Opening feed ──────────────────────────────────────────────────────────────

// Opening feed inside the widget — latest emerging themes + watchlist risks to monitor.
function BriefPanel({ brief, navigate }) {
  if (!brief || (!brief.emergingThemes?.length && !brief.activeRisks?.length)) return null;
  const RATING = { VL: "#c8e6c9", L: "#388e3c", M: "#fdd835", H: "#ef6c00", E: "#c62828" };
  const row = { display: "flex", alignItems: "center", gap: 0.75, py: 0.4, cursor: "pointer" };
  return (
    <Box sx={{ px: 2, py: 1.25, borderBottom: "1px solid rgba(0,0,0,0.08)", bgcolor: "#faf9fc" }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: "#6a6478", letterSpacing: 0.5, display: "block" }}
      >
        Emerging themes to watch
      </Typography>
      {(brief.emergingThemes || []).slice(0, 5).map((t) => (
        <Box
          key={t.themeTag || t.name}
          onClick={() => navigate("/anticipate/HorizonScan")}
          sx={{ ...row, "&:hover .n": { color: "#52009b" } }}
        >
          <Box
            sx={{
              flex: "none",
              minWidth: 22,
              textAlign: "center",
              fontSize: 10,
              fontWeight: 800,
              color: "#fff",
              borderRadius: 0.5,
              bgcolor: RATING[t.rating] || "#9990a8",
            }}
          >
            {t.rating || "–"}
          </Box>
          <Typography className="n" variant="caption" sx={{ flex: 1, lineHeight: 1.3 }}>
            {t.name}
          </Typography>
          {t.newAlertsToday > 0 && (
            <Typography variant="caption" sx={{ color: "#0a5bb0", fontWeight: 700 }}>
              +{t.newAlertsToday}
            </Typography>
          )}
        </Box>
      ))}
      <Typography
        variant="caption"
        sx={{ fontWeight: 700, color: "#6a6478", letterSpacing: 0.5, display: "block", mt: 1 }}
      >
        Watchlist risks to monitor
      </Typography>
      {(brief.activeRisks || []).slice(0, 5).map((r) => (
        <Box
          key={r.id || r.title}
          onClick={() => navigate("/anticipate/EmergingRisks")}
          sx={{ ...row, "&:hover .n": { color: "#52009b" } }}
        >
          <Typography className="n" variant="caption" sx={{ flex: 1, lineHeight: 1.3 }}>
            {r.title}
          </Typography>
          {r.trendDirection === "worsening" && (
            <Typography variant="caption" sx={{ color: "#c62828", fontWeight: 700 }}>
              ⚠
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}

// ── Main widget ───────────────────────────────────────────────────────────────

export default function RiskAdvisorWidget() {
  const getToken = useAuthToken();
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  // The user can dismiss the floating launcher for the current page; it returns on navigation.
  const [hidden, setHidden] = useState(false);
  const [brief, setBrief] = useState(null); // opening feed — emerging themes + watchlist to monitor

  // Ask PAGER — pure, ephemeral Q&A thread (no server-persisted sessions).
  const [askMessages, setAskMessages] = useState([]); // { role: 'user'|'assistant', text }
  const [askInput, setAskInput] = useState("");
  const [asking, setAsking] = useState(false);

  const chatEndRef = useRef(null);
  const inputRef = useRef(null);
  const focusInput = useCallback(() => {
    // Defer so it runs after the re-render that re-enables the input / finishes the click.
    setTimeout(() => inputRef.current?.focus(), 0);
  }, []);

  // Screen-aware: keep the latest "what's on screen" snapshot in a ref so `askPager` always attaches
  // the CURRENT screen context (rich data only when the publishing screen matches the current route).
  const { screen } = useScreenContext();
  const screenCtxRef = useRef({ route: "", screenName: "", data: null });
  useEffect(() => {
    const route = location.pathname;
    screenCtxRef.current = {
      route,
      screenName: screenNameForRoute(route),
      data: screen && screen.route === route ? screen.data : null,
    };
  }, [screen, location.pathname]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [askMessages]);

  // Keep the typing cursor in the chat input: a disabled input (while a reply streams) drops focus,
  // so restore it as soon as streaming ends.
  useEffect(() => {
    if (!asking) focusInput();
  }, [asking, focusInput]);

  // Bring the launcher back whenever the user navigates to another page.
  useEffect(() => {
    setHidden(false);
  }, [location.pathname]);

  const loadBrief = useCallback(async () => {
    const token = await getToken();
    if (!token) return;
    try {
      const res = await fetch(`${API}/advisor/brief?themes=6&risks=6`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      if (json?.data) setBrief(json.data);
    } catch (_) {}
  }, [getToken]);

  useEffect(() => {
    if (open && !brief) loadBrief();
  }, [open, brief, loadBrief]);

  // Ask PAGER — grounded, screen-aware Q&A (streams from /advisor/ask). Stateless: nothing persisted.
  const askPager = useCallback(
    async (explicit) => {
      const q = (typeof explicit === "string" ? explicit : askInput).trim();
      if (!q || asking) return;
      setAskInput("");
      const history = askMessages.slice(-8);
      setAskMessages((m) => [...m, { role: "user", text: q }, { role: "assistant", text: "" }]);
      setAsking(true);
      const token = await getToken();
      try {
        await streamMessage(
          `${API}/advisor/ask`,
          { message: q, history, screenContext: screenCtxRef.current },
          token,
          (ev) => {
            if (ev.type === "text_delta") {
              setAskMessages((m) => {
                const copy = m.slice();
                const last = copy[copy.length - 1];
                if (last && last.role === "assistant") {
                  copy[copy.length - 1] = { ...last, text: last.text + ev.text };
                }
                return copy;
              });
            } else if (ev.type === "proposal") {
              // The advisor proposed an action — attach it to the current assistant turn as a card.
              setAskMessages((m) => {
                const copy = m.slice();
                const last = copy[copy.length - 1];
                if (last && last.role === "assistant") {
                  copy[copy.length - 1] = {
                    ...last,
                    proposal: { kind: ev.kind, data: ev.data || {} },
                  };
                }
                return copy;
              });
            }
          }
        );
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          const last = copy[copy.length - 1];
          if (last && last.role === "assistant" && !last.text) {
            copy[copy.length - 1] = { ...last, text: "Sorry — I couldn't answer that just now." };
          }
          return copy;
        });
      }
      setAsking(false);
    },
    [askInput, asking, askMessages, getToken]
  );

  // Confirm a proposed action (create watchlist risk / horizon search) — POST /advisor/confirm.
  const confirmAction = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = { ...copy[idx], proposal: { ...copy[idx].proposal, busy: true } };
        return copy;
      });
      const token = await getToken();
      try {
        const res = await fetch(`${API}/advisor/confirm`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({ kind: proposal.kind, data: proposal.data }),
        });
        const json = await res.json().catch(() => ({}));
        const ok = res.ok && json?.status !== false && json?.success !== false;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx]) {
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                done: ok,
                result: ok ? json?.data || {} : null,
                error: ok ? null : json?.message || "Couldn't complete that action.",
              },
            };
          }
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't complete that action.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  const dismissAction = useCallback((idx) => {
    setAskMessages((m) => {
      const copy = m.slice();
      if (copy[idx])
        copy[idx] = { ...copy[idx], proposal: { ...copy[idx].proposal, dismissed: true } };
      return copy;
    });
  }, []);

  // Generate a board paper from a confirmed board_paper proposal — drives the existing report
  // generator (POST /boardPaper/generate) with the conversational scope, then offers to open it.
  const generateBoardPaper = useCallback(
    async (idx) => {
      const target = askMessages[idx];
      const proposal = target && target.proposal;
      if (!proposal || proposal.busy || proposal.done) return;
      setAskMessages((m) => {
        const copy = m.slice();
        if (copy[idx])
          copy[idx] = {
            ...copy[idx],
            proposal: { ...copy[idx].proposal, busy: true, error: null },
          };
        return copy;
      });
      focusInput(); // clicking Generate blurs the input — give the cursor back so the user can keep chatting
      const d = proposal.data || {};
      const token = await getToken();
      const LENGTH_PAGES = { short: "1 page", standard: "2 pages", detailed: "4 pages" };

      // Resolve specific named risks → watchlist risk ids (best-effort, case-insensitive match).
      let watchlistRiskIds = [];
      if (Array.isArray(d.focusRisks) && d.focusRisks.length) {
        try {
          const lr = await fetch(`${API}/emergingRisk/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const lj = await lr.json().catch(() => ({}));
          const risks = Array.isArray(lj?.data) ? lj.data : [];
          const wanted = d.focusRisks.map((s) => String(s).toLowerCase().trim()).filter(Boolean);
          watchlistRiskIds = risks
            .filter((r) => {
              const title = String(r.Title || r.title || "").toLowerCase();
              return title && wanted.some((w) => title.includes(w) || w.includes(title));
            })
            .map((r) => String(r._id || r.id))
            .filter(Boolean);
        } catch (_) {
          /* fall back to category / whole-portfolio scope */
        }
      }

      // Resolve a named stored template → its id (case-insensitive). The template's own format
      // (docx/pptx) then wins for the output, so "use the exec slides template" produces slides.
      let templateId;
      let templateFormat;
      if (d.template && String(d.template).trim()) {
        try {
          const tr = await fetch(`${API}/reportTemplate/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const tj = await tr.json().catch(() => ({}));
          const tpls = Array.isArray(tj?.data) ? tj.data : [];
          const want = String(d.template).toLowerCase().trim();
          const match =
            tpls.find(
              (t) =>
                String(t.name || "")
                  .toLowerCase()
                  .trim() === want
            ) ||
            tpls.find((t) => {
              const nm = String(t.name || "")
                .toLowerCase()
                .trim();
              return nm && (nm.includes(want) || want.includes(nm));
            });
          if (match) {
            templateId = match.id || match._id;
            templateFormat = match.format;
          }
        } catch (_) {
          /* fall back to default formatting */
        }
      }

      // Resolve named Horizon Scan collections (company-search parameter name OR category) → ids, so
      // the paper's emerging-theme analysis is scoped to just those collections.
      let horizonParamIds = [];
      if (Array.isArray(d.focusHorizonParams) && d.focusHorizonParams.length) {
        try {
          const pr = await fetch(`${API}/companySearchParameters/list`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          const pj = await pr.json().catch(() => ({}));
          const params = Array.isArray(pj?.data) ? pj.data : [];
          const wanted = d.focusHorizonParams
            .map((s) => String(s).toLowerCase().trim())
            .filter(Boolean);
          horizonParamIds = params
            .filter((p) => {
              const nm = String(p.name || "").toLowerCase();
              const cat = String(p.category || "").toLowerCase();
              return wanted.some(
                (w) => (nm && (nm === w || nm.includes(w) || w.includes(nm))) || (cat && cat === w)
              );
            })
            .map((p) => String(p._id || p.id))
            .filter(Boolean);
        } catch (_) {
          /* fall back to the taxonomy / whole-portfolio scope */
        }
      }

      // Reporting period → date range (explicit dates win; else a relative month lookback).
      let dateMode = "current";
      let dateFrom;
      let dateTo;
      if (d.dateFrom && d.dateTo) {
        dateMode = "date-range";
        dateFrom = d.dateFrom;
        dateTo = d.dateTo;
      } else if (Number(d.periodMonths) > 0) {
        const to = new Date();
        const from = new Date();
        from.setMonth(from.getMonth() - Number(d.periodMonths));
        dateMode = "date-range";
        dateFrom = from.toISOString().slice(0, 10);
        dateTo = to.toISOString().slice(0, 10);
      }

      const body = {
        reportType: ["strategic", "operational", "tactical"].includes(d.reportType)
          ? d.reportType
          : "strategic",
        scope: "all",
        includeCharts: d.includeCharts !== false,
        anticipatory: true,
        riskCategoriesL1: Array.isArray(d.focusCategories) ? d.focusCategories : [],
        riskCategoriesL2: Array.isArray(d.focusSubCategories) ? d.focusSubCategories : [],
        watchlistRiskIds,
        horizonParamIds,
        length: LENGTH_PAGES[d.length] || "2 pages",
        dateMode,
        dateFrom,
        dateTo,
        structure: d.notes || "",
        // A chosen template's format wins; otherwise honour the requested output format.
        outputFormat: templateFormat || (d.outputFormat === "pptx" ? "pptx" : "docx"),
        templateId,
      };
      try {
        const res = await fetch(`${API}/boardPaper/generate`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body),
        });
        const json = await res.json().catch(() => ({}));
        const ok = res.ok && json?.success !== false && json?.data?.reportId;
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                done: !!ok,
                result: ok ? json.data : null,
                error: ok ? null : json?.message || "Couldn't generate the board paper.",
              },
            };
          return copy;
        });
      } catch (_) {
        setAskMessages((m) => {
          const copy = m.slice();
          if (copy[idx])
            copy[idx] = {
              ...copy[idx],
              proposal: {
                ...copy[idx].proposal,
                busy: false,
                error: "Couldn't generate the board paper.",
              },
            };
          return copy;
        });
      }
    },
    [askMessages, getToken]
  );

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      askPager();
    }
  };

  // Dismissed for this page — hide everything until the user navigates.
  if (hidden) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "2rem",
        left: "2rem",
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      {/* Chat window */}
      {open && (
        <Box
          sx={{
            width: 600,
            height: 620,
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            border: "1px solid rgba(0,0,0,0.1)",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              px: 2,
              py: 1.25,
              bgcolor: "#7b1fa2",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ChatIcon sx={{ color: "#fff", fontSize: 18 }} />
              <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: 700 }}>
                Ask PAGER
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {askMessages.length > 0 && (
                <Button
                  size="small"
                  startIcon={<AddIcon sx={{ fontSize: 14 }} />}
                  onClick={() => {
                    setAskMessages([]);
                    setAskInput("");
                  }}
                  sx={{
                    color: "#fff",
                    textTransform: "none",
                    fontSize: "0.72rem",
                    py: 0.25,
                    minWidth: 0,
                    "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
                  }}
                >
                  New chat
                </Button>
              )}
              <IconButton
                size="small"
                onClick={() => {
                  setOpen(false);
                }}
                sx={{ color: "#fff", p: "4px" }}
              >
                <CloseIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Box>

          {/* Body — opening feed + ask thread + ask input (full width) */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <Box sx={{ flex: 1, overflowY: "auto" }}>
              {/* Opening feed — themes + watchlist to monitor; hides once a conversation starts. */}
              {askMessages.length === 0 && <BriefPanel brief={brief} navigate={navigate} />}

              {askMessages.length === 0 ? (
                <Box sx={{ px: 2, py: 2.5 }}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", textAlign: "center", mb: 1.5, lineHeight: 1.6 }}
                  >
                    Ask about today&apos;s risks — which themes moved, which risks are worsening —
                    or ask me to build a board paper.
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, justifyContent: "center" }}
                  >
                    {[
                      "What's emerging this week?",
                      "Which risks are worsening?",
                      "Build me a board paper",
                    ].map((s) => (
                      <Button
                        key={s}
                        size="small"
                        variant="outlined"
                        disabled={asking}
                        onClick={() => askPager(s)}
                        sx={{
                          textTransform: "none",
                          fontSize: 12,
                          color: "#7b1fa2",
                          borderColor: "#d8c7ec",
                          bgcolor: "#fff",
                          "&:hover": { borderColor: "#7b1fa2", bgcolor: "#f7f2fb" },
                        }}
                      >
                        {s}
                      </Button>
                    ))}
                  </Box>
                </Box>
              ) : (
                <Box sx={{ px: 2, py: 1.5, display: "flex", flexDirection: "column", gap: 1 }}>
                  {askMessages.map((m, i) => (
                    <React.Fragment key={i}>
                      {(m.text || m.role === "user" || !(m.proposal && !m.proposal.dismissed)) && (
                        <Box
                          sx={{
                            alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                            maxWidth: "85%",
                            bgcolor: m.role === "user" ? "#7b1fa2" : "#f3eefa",
                            color: m.role === "user" ? "#fff" : "#222028",
                            borderRadius: 2,
                            px: 1.5,
                            py: 1,
                            fontSize: 13.5,
                            whiteSpace: "pre-wrap",
                            lineHeight: 1.5,
                          }}
                        >
                          {m.text || (asking && i === askMessages.length - 1 ? "…" : "")}
                        </Box>
                      )}
                      {m.proposal && !m.proposal.dismissed && (
                        <ProposalCard
                          proposal={m.proposal}
                          onConfirm={() =>
                            m.proposal.kind === "board_paper"
                              ? generateBoardPaper(i)
                              : confirmAction(i)
                          }
                          onDismiss={() => dismissAction(i)}
                          onOpen={(riskId) => {
                            setOpen(false);
                            navigate("/anticipate/EmergingRisks", {
                              state: { openRiskId: riskId },
                            });
                          }}
                          onOpenBoardPaper={(reportId) => {
                            setOpen(false);
                            navigate(`/anticipate/board-paper?view=${reportId}`);
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                  <div ref={chatEndRef} />
                </Box>
              )}
            </Box>

            {/* Ask input */}
            <Box
              sx={{
                px: 1.5,
                py: 1,
                borderTop: "1px solid rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "flex-end",
                gap: 0.75,
              }}
            >
              <TextField
                fullWidth
                multiline
                maxRows={4}
                inputRef={inputRef}
                placeholder="Ask about today's risks — which themes moved, which risks are worsening…"
                value={askInput}
                onChange={(e) => setAskInput(e.target.value)}
                onKeyDown={onKeyDown}
                disabled={asking}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    fontSize: "0.8rem",
                    "&.Mui-focused fieldset": { borderColor: "#7b1fa2" },
                  },
                }}
              />
              <IconButton
                onClick={askPager}
                disabled={!askInput.trim() || asking}
                sx={{
                  bgcolor: "#7b1fa2",
                  color: "#fff",
                  "&:hover": { bgcolor: "#6a1b9a" },
                  "&.Mui-disabled": { bgcolor: "#e0e0e0", color: "#9e9e9e" },
                  width: 36,
                  height: 36,
                  flexShrink: 0,
                }}
              >
                {asking ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <SendIcon sx={{ fontSize: 16 }} />
                )}
              </IconButton>
            </Box>
          </Box>
        </Box>
      )}

      {/* FAB with a dismiss badge to hide the launcher for this page */}
      <Box sx={{ position: "relative" }}>
        {!open && (
          <Tooltip title="Hide Ask PAGER (returns on next page)">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                setHidden(true);
              }}
              sx={{
                position: "absolute",
                top: -4,
                right: -4,
                zIndex: 1,
                width: 22,
                height: 22,
                bgcolor: "#fff",
                color: "#7b1fa2",
                border: "1px solid rgba(123,31,162,0.45)",
                boxShadow: "0 1px 5px rgba(0,0,0,0.25)",
                "&:hover": { bgcolor: "#f3e5f5" },
              }}
            >
              <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        )}
        <Fab
          onClick={() => setOpen((v) => !v)}
          sx={{
            bgcolor: "#7b1fa2",
            color: "#fff",
            "&:hover": { bgcolor: "#6a1b9a" },
            boxShadow: "0 4px 16px rgba(123,31,162,0.4)",
            width: 56,
            height: 56,
          }}
        >
          {open ? <CloseIcon /> : <ChatIcon />}
        </Fab>
      </Box>

      {/* Label shown when closed */}
      {!open && (
        <Typography
          variant="caption"
          sx={{
            color: "#7b1fa2",
            fontWeight: 700,
            textAlign: "center",
            letterSpacing: 0.5,
            userSelect: "none",
            pointerEvents: "none",
          }}
        >
          Ask PAGER
        </Typography>
      )}
    </Box>
  );
}
